"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";
import { Button } from "@/shared/ui/buttons/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/shared/ui/modals/dialog";
import { Label } from "@/shared/ui/forms/label";
import { RespondMessageField } from "./respond-message-field";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/shared/ui/inputs/select";

export interface InviteTeamOption {
  id: string;
  name: string;
}

interface BoardInviteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  teams: InviteTeamOption[];
  onInvite: (teamId: string, message: string) => void;
}

/** Выбор команды, от которой зовём игрока. Одна команда — выбрана сразу. */
export function BoardInviteDialog({ open, onOpenChange, teams, onInvite }: BoardInviteDialogProps) {
  const t = useTranslations("LfgBoard");
  const [picked, setPicked] = useState("");
  const [message, setMessage] = useState("");
  const teamId = picked || (teams.length === 1 ? teams[0]!.id : "");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t("card.inviteTitle")}</DialogTitle>
        </DialogHeader>
        <div className="space-y-2">
          <Label htmlFor="lfg-invite-team">{t("card.inviteTeam")}</Label>
          <Select value={teamId} onValueChange={setPicked}>
            <SelectTrigger id="lfg-invite-team">
              <SelectValue placeholder={t("card.inviteTeamPlaceholder")} />
            </SelectTrigger>
            <SelectContent>
              {teams.map((team) => (
                <SelectItem key={team.id} value={team.id}>{team.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <RespondMessageField value={message} onChange={setMessage} />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>{t("card.cancel")}</Button>
          <Button
            disabled={!teamId}
            onClick={() => {
              onInvite(teamId, message);
              onOpenChange(false);
              setPicked("");
              setMessage("");
            }}
          >
            {t("card.inviteSend")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
